import { Box, Skeleton, Typography } from "@mui/material";
import { memo } from "react";

import type { CompactStatsRowProps } from "./CompactStatsRow.types";
import * as styles from "./CompactStatsRow.styles";

export type { CompactStatsRowProps } from "./CompactStatsRow.types";

export const CompactStatsRow = memo(function CompactStatsRow({
  items,
  isLoading = false,
}: CompactStatsRowProps) {
  return (
    <Box sx={styles.root}>
      {items.map((item) => (
        <Box key={item.label} sx={styles.card}>
          <Box sx={styles.iconWrap(item.softBg)}>{item.icon}</Box>
          <Box sx={styles.valueBlock}>
            {isLoading ? (
              <Skeleton variant="text" width="60%" height={24} />
            ) : (
              <Typography sx={styles.value}>{item.value}</Typography>
            )}
            <Typography sx={styles.label}>{item.label}</Typography>
          </Box>
        </Box>
      ))}
    </Box>
  );
});
